var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72171",
    "data-name": "Path 72171",
    d: "M7.254,18.494l.725.423a8,8,0,1,0-2.894-2.893l.422.724-.653,2.4ZM2.005,22l1.352-4.969a10,10,0,1,1,3.614,3.613ZM8.392,7.308a3.385,3.385,0,0,1,.4,0c.054,0,.108.01.162.016a.506.506,0,0,1,.393.249q.447,1.015.868,2.041a.606.606,0,0,1-.093.536,4.353,4.353,0,0,1-.263.373c-.113.145-.356.411-.356.411a.324.324,0,0,0-.061.265.923.923,0,0,0,.1.2l.059.095a6.3,6.3,0,0,0,1.02,1.268c.12.117.237.236.363.346a6.014,6.014,0,0,0,1.57,1l.005,0,.252.109a1.429,1.429,0,0,0,.192.066.394.394,0,0,0,.072.011.35.35,0,0,0,.3-.142,12.131,12.131,0,0,1,.795-.933v0a.483.483,0,0,1,.378-.127.5.5,0,0,1,.177.041c.532.243,1.4.621,1.4.621l.582.261a.341.341,0,0,1,.191.265,2,2,0,0,1-.014.372,2.758,2.758,0,0,1-.188.733,1.158,1.158,0,0,1-.209.3,2.381,2.381,0,0,1-.331.288c-.082.061-.125.09-.125.09-.139.088-.217.131-.383.219a1.99,1.99,0,0,1-.833.231,5.3,5.3,0,0,1-.556.013l-.568-.087A9.448,9.448,0,0,1,9.85,14.4c-.226-.2-.435-.414-.648-.626a9.523,9.523,0,0,1-1.97-2.742A3.472,3.472,0,0,1,6.9,9.621a2.729,2.729,0,0,1,.565-1.679,2.261,2.261,0,0,1,.261-.306,1.293,1.293,0,0,1,.293-.228A.961.961,0,0,1,8.392,7.308Z",
    transform: "translate(-2.001 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.95ae24f8dc99c7acea954a6fcd5c36e4.svg";
export { ForwardRef as ReactComponent };